import axios from 'axios'

// baseURL should point to the backend API (including the /api prefix)
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || 'http://127.0.0.1:3000/api',
  timeout: 10000
})

// Request interceptor: attach Authorization header from localStorage
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }
  } catch (e) {
    // ignore
  }
  return config
}, (error) => Promise.reject(error))

// Response interceptor: handle 401 globally
api.interceptors.response.use((res) => res, (err) => {
  if (err?.response?.status === 401) {
    // clear token and redirect to login
    try { localStorage.removeItem('admin_token') } catch (e) {}
    window.location.href = '/login'
  }
  return Promise.reject(err)
})

export const auth = {
  login (username, password) {
    return api.post('/admin/login', { username, password })
  }
}

export const users = {
  list (params) { return api.get('/users', { params }) },
  get (id) { return api.get(`/users/${id}`) },
  create (data) { return api.post('/users', data) },
  update (id, data) { return api.put(`/users/${id}`, data) },
  remove (id) { return api.delete(`/users/${id}`) }
}

export const admins = {
  list (params) { return api.get('/admins', { params }) },
  create (data) { return api.post('/admins', data) },
  update (id, data) { return api.put(`/admins/${id}`, data) },
  remove (id) { return api.delete(`/admins/${id}`) }
}

export default api

// Utility: parse JWT payload (no verification) to get admin info for UI
export function parseToken (token) {
  if (!token) return null
  try {
    const parts = token.split('.')
    if (parts.length < 2) return null
    const payload = parts[1]
    const json = decodeURIComponent(atob(payload).split('').map(function(c){
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}
